import {
  setConductricsSelectionOK,
  Status,
  useConductricsSelection,
} from '@dx-ui/framework-conductrics';
import { logWarning } from '@dx-ui/framework-logger';

export function useEmailErrorRedesignTest() {
  const AGENT_ID = 'a-auth-792';
  const { isLoaded } = useConductricsSelection(AGENT_ID, Status.PENDING);
  const startEmailErrorTest = async () => {
    const res = await setConductricsSelectionOK(AGENT_ID).catch((error) =>
      logWarning('Unable to set OK on conductrics selection', error, AGENT_ID)
    );
    const isWarningWithLinks = isLoaded && res?.sels?.[AGENT_ID] === 'B';
    const isErrorWithLinks = isLoaded && res?.sels?.[AGENT_ID] === 'C';
    return { isWarningWithLinks, isErrorWithLinks };
  };
  return { startEmailErrorTest, isEmailErrorTestLoaded: isLoaded };
}
